'use client';
import React, { useState, useMemo } from 'react';
import { BASE_FILE_URL } from '@/common/constants';
import { useTranslations } from 'next-intl';
import get from 'lodash/get';
import { formatDateVN } from '@/common/ultils';

export default function ModalBangKienNghi({ row }) {
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations('');
  const plainTextContent = useMemo(() => {
    if (typeof document === 'undefined') return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = row.content || '';
    return tempDiv.textContent || tempDiv.innerText || '';
  }, [row.content]);

  const NGUON_TIEP_NHAN_Y_KIEN = [
    {
      label: 'Website',
      value: 'website',
    },
    {
      label: 'Email',
      value: 'email',
    },
    {
      label: 'Trực tiếp',
      value: 'truc_tiep',
    },
  ];

  const LINH_VUV_Y_KIEN = [
    {
      label: 'Kinh tế',
      value: 'kinh_te',
    },
    {
      label: 'Xã hội',
      value: 'xa_hoi',
    },
    {
      label: 'Giáo dục',
      value: 'giao_duc',
    },
    {
      label: 'Chính trị',
      value: 'chinh_tri',
    },
  ];

  const PHAN_LOAI_Y_KIEN = [
    {
      label: 'Ý kiến cần xin ý kiến từ phòng ban',
      value: 'phong_ban',
    },
    {
      label: 'Đại biểu chuyên trách/ý kiến đã có câu trả lời từ đại biểu',
      value: 'dai_bieu_chuyen_trach',
    },
    // {
    //   label: 'Ý kiến đã có câu trả lời từ đại biểu',
    //   value: 'da_co_cau_tra_loi',
    // },
  ];

  const wordCount = plainTextContent.trim().split(/\s+/).length;
  const containerClass = `text-left ${wordCount < 100 ? 'flex' : ''}`;

  return (
    <>
      <button
        className="text-blue-600 underline hover:text-blue-800 p-1 
                   rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2
                   focus:ring-offset-1 focus:ring-blue-500 cursor-pointer"
        onClick={() => setIsOpen(true)}>
        {t('home.viewDetail')}
      </button>

      {isOpen && (
        <div className="fixed inset-0 bg-black/20 flex items-center justify-center z-50 overflow-y-auto h-full">
          <div className="bg-white p-6 rounded shadow-lg relative w-full max-w-[1280px]">
            <button className="absolute top-0 right-5 text-[42px] cursor-pointer" onClick={() => setIsOpen(false)}>
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4 text-red-600">{t('voterOpinions.viewDetail.title')}</h2>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold">{t('voterOpinions.viewDetail.receivedDate')}</div>:{formatDateVN(row.receiveDate)}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold">{t('voterOpinions.viewDetail.source')}</div>:
              {NGUON_TIEP_NHAN_Y_KIEN.find((v) => v.value === row.receiveOrigin)?.label ?? ''}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold">{t('voterOpinions.viewDetail.field')}</div>:
              {LINH_VUV_Y_KIEN.find((v) => v.value === row?.fieldType)?.label ?? ''}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold">{t('voterOpinions.viewDetail.category')}</div>:
              {PHAN_LOAI_Y_KIEN.find((v) => v.value === row?.opinionClass)?.label ?? ''}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold">{t('voterOpinions.viewDetail.sender')}</div>: {row.senderName}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold">{t('voterOpinions.viewDetail.phone')}</div>: {row.phoneNumber}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold">{t('voterOpinions.viewDetail.attachments')}</div>:
              {JSON.parse(row?.fileUrls).map((item) => (
                <a href={`${BASE_FILE_URL}/${item}`} key={item} alt="img" className="text-blue-500 italic underline w-[300px] truncate">
                  {item}
                </a>
              ))}
            </div>
            <div className="text-left flex">
              <div className="w-[200px] font-semibold">{t('voterOpinions.viewDetail.email')}</div>: {row.email}
            </div>
            {/* <div className="text-left flex">
              <div className="w-[200px] font-semibold">Hình thức gửi</div>: {row.hinhThucGui}
            </div> */}
            <div className={containerClass}>
              <div className="flex">
                <div className="w-[200px] font-semibold">{t('voterOpinions.viewDetail.content')}</div> :
              </div>
              <div dangerouslySetInnerHTML={{ __html: row?.content ?? '' }} className="ml-[2px]" />
            </div>
            <div>
              <div className="flex">
                <div className="w-[200px] font-semibold text-left">{t('voterOpinions.viewDetail.additionalReply')}</div> :
                <div dangerouslySetInnerHTML={{ __html: row?.plusContent ?? '' }} className="ml-[2px] text-left" />
              </div>
            </div>
            {get(row, 'yKienCuTriStaffs', []).map((item) => (
              <>
                <div className="text-left font-semibold mt-5">
                  {t('voterOpinions.viewDetail.delegateReply')} {get(item, 'staff.name', '')}
                </div>
                <div>
                  <div className="flex">
                    <div className="w-[200px] font-semibold text-left">{t('voterOpinions.viewDetail.content')}</div> :
                    <div dangerouslySetInnerHTML={{ __html: item?.anwserContent ?? '' }} className="ml-[2px] text-left" />
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
